import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';
import { DataGrid, GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import { Add } from '@mui/icons-material';
import procurementService from '../../services/procurement.service';
import { useLanguage } from '../../i18n/LanguageContext';

const GoodsReceiptList: React.FC = () => {
  const [receipts, setReceipts] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { t } = useLanguage();

  useEffect(() => { loadReceipts(); }, []);

  const loadReceipts = async () => {
    try {
      const res = await procurementService.getGoodsReceipts();
      setReceipts(res.data);
    } catch (error) { console.error('Error loading goods receipts:', error); }
    finally { setLoading(false); }
  };

  const columns: GridColDef[] = [
    { field: 'receiptNumber', headerName: t('goods_receipts.receipt_number'), width: 200 },
    {
      field: 'receiptDate', headerName: t('common.date'), width: 120,
      renderCell: (params: GridRenderCellParams) => new Date(params.value).toLocaleDateString()
    },
    { field: 'purchaseOrderNumber', headerName: t('goods_receipts.po_number'), width: 200 },
    { field: 'supplierName', headerName: t('purchase_orders.supplier'), flex: 1 },
    { field: 'lineCount', headerName: t('goods_receipts.items'), width: 80, align: 'center' },
    { field: 'totalQuantity', headerName: t('goods_receipts.total_qty'), width: 100, align: 'center' },
    { field: 'notes', headerName: t('common.notes'), width: 200 },
  ];

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>
        <Typography variant="h4">{t('goods_receipts.title')}</Typography>
        <Button variant="contained" startIcon={<Add />} onClick={() => navigate('/goods-receipts/new')}>
          {t('goods_receipts.new')}
        </Button>
      </Box>
      <DataGrid rows={receipts} columns={columns} loading={loading} autoHeight
        initialState={{ pagination: { paginationModel: { pageSize: 25 } } }}
        pageSizeOptions={[25, 50]} disableRowSelectionOnClick />
    </Box>
  );
};

export default GoodsReceiptList;
